import { BellAlertIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { TableStateLayout } from '../../shared/TableStateLayout';
import { INBOX_TD_PADDING } from '../shared/inboxColumnStyles';

const SKELETON_ROW_COUNT = 6;

function Bar({ width }: { width: string }) {
    return <div className={`h-3 rounded bg-gray-200 animate-pulse ${width}`} />;
}

function SkeletonRow() {
    return (
        <tr className="h-14 border-b border-gray-200">
            <td className={INBOX_TD_PADDING}>
                <div className="flex items-center gap-2.5">
                    <div className="h-4 w-4 shrink-0 rounded bg-gray-100" />
                    <div className="h-[30px] w-[30px] shrink-0 rounded-full bg-gray-200 animate-pulse" />
                    <div className="flex flex-1 flex-col gap-1.5">
                        <Bar width="w-28" />
                        <Bar width="w-20" />
                    </div>
                </div>
            </td>
            <td className={INBOX_TD_PADDING}>
                <div className="h-[42px] w-[42px] rounded-full bg-gray-100 animate-pulse" />
            </td>
            <td className={INBOX_TD_PADDING}>
                <div className="h-6 w-6 rounded-full bg-gray-200 animate-pulse" />
            </td>
            <td className={INBOX_TD_PADDING}>
                <Bar width="w-36" />
            </td>
            <td className={INBOX_TD_PADDING}>
                <Bar width="w-14" />
            </td>
            <td className={INBOX_TD_PADDING}>
                <div className="ml-auto h-7 w-14 rounded-md bg-gray-200 animate-pulse" />
            </td>
        </tr>
    );
}

export function NotificationsSkeletonRows() {
    return (
        <>
            {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
                <SkeletonRow key={index} />
            ))}
        </>
    );
}

interface NotificationsEmptyStateProps {
    filtersActive: boolean;
    onClearFilters: () => void;
    closed: boolean;
}

export function NotificationsEmptyState({
    filtersActive,
    onClearFilters,
    closed
}: NotificationsEmptyStateProps) {
    if (filtersActive) {
        return (
            <TableStateLayout
                icon={BellAlertIcon}
                title="No notifications match these filters"
                text="Clear the search and filters to see every notification."
                actionLabel="Clear filters"
                onAction={onClearFilters}
            />
        );
    }
    if (closed) {
        return (
            <TableStateLayout
                icon={BellAlertIcon}
                title="Nothing closed in the last 24 hours"
                text="Patients whose notifications were all handled recently will show here."
            />
        );
    }
    return (
        <TableStateLayout
            icon={BellAlertIcon}
            title="No DM notifications"
            text="Dental Monitoring notifications that need action will show here."
        />
    );
}

export function NotificationsErrorState({ onRetry }: { onRetry: () => void }) {
    return (
        <TableStateLayout
            icon={ExclamationTriangleIcon}
            title="Couldn't load notifications"
            text="Something went wrong fetching the list. Try again."
            actionLabel="Retry"
            onAction={onRetry}
        />
    );
}
